import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installErrorReporter } from "@/lib/errorReporter";

// Swallow the benign "ResizeObserver loop completed with undelivered
// notifications" warning so CRA's dev error overlay doesn't pin a fake
// fatal-looking modal over the page. Triggered by Radix Switch inside
// Radix Table on /recurring and /blackouts; harmless in production.
if (typeof window !== "undefined") {
  const swallow = (msg) =>
    typeof msg === "string" && msg.toLowerCase().includes("resizeobserver");
  window.addEventListener("error", (e) => {
    if (swallow(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    if (swallow(e.reason?.message || e.reason)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
  installErrorReporter();
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
